/**
 * @fileoverview Frontend-only UI grouping config for the Summarisation tab.
 *
 * Purpose:
 * - Provide the order and label for each summarisation group shown on the
 *   Gather → Summarise screen.
 * - The list of agents and their `group` membership lives on each manifest
 *   (see `convex/jobs/summarization/agents/<name>/manifest.ts`); this file
 *   only owns the visual sorting.
 *
 * Used by:
 * - SummarizationView.tsx
 */

import type { SummarizationGroupId } from "@cvx/jobs/summarization/types";

export interface SummarizationGroupDisplay {
  id: SummarizationGroupId;
  label: string;
}

/**
 * Group order is intentional — Foundation summaries come first because every
 * other agent benefits from the corporate / indicator output as context.
 */
export const SUMMARIZATION_GROUPS: ReadonlyArray<SummarizationGroupDisplay> = [
  { id: "foundation", label: "Foundation" },
  { id: "financial", label: "Financial" },
  { id: "assets", label: "Assets" },
  { id: "liabilities", label: "Liabilities" },
];
